export const STATUS_OPTIONS = {
  all: { key: 'all', title: 'All statuses' },
  None: { key: 'None', title: 'Not started' },
  Draft: { key: 'Draft', title: 'Draft' },
  Declared: { key: 'Declared', title: 'Declared' },
} as const;

// Only columns that actually expose a sort control belong here. Cargos are bulk-created with
// identical `createdAt`, so voyage (the reference customers actually recognise) is the default
// order and the universal tie-breaker. `declaredAt` used to be missing here, which silently
// reset the "Declared At" sort back to the default via validateSearch's `.catch`.
export const SORT_OPTIONS = [
  'voyage:asc',
  'voyage:desc',
  'createdAt:asc',
  'createdAt:desc',
  'declaredAt:asc',
  'declaredAt:desc',
] as const;
export type SortOption = (typeof SORT_OPTIONS)[number];

export const DEFAULT_SORT: SortOption = 'voyage:asc';

export const DEFAULT_SEARCH_PARAMS = {
  sortBy: DEFAULT_SORT,
  status: STATUS_OPTIONS.all.key,
  search: '',
  page: 0,
  includeCompleted: false,
} as const;
